import React from 'react';
import FCContainer from './FCContainer';

const financialCalculatorUrl = window.skodaVariables.componentsUrl.financialCalculator;
const widgetURL = financialCalculatorUrl + "/widgets/calculator-v2.min.js";

function App() {
  return (
      <div className="App">
          <FCContainer
              widget={widgetURL}
              endpoint={financialCalculatorUrl}
          />
      </div>
  );
}

export default App;